function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M113.029 96.8379L91.7048 59.9032L85.0002 71.516L85.9238 73.1157L85.9244 73.1154L101.286 99.7227H111.364C112.844 99.7227 113.769 98.12 113.029 96.8379ZM83.1537 68.3179L83.1541 68.3185L89.8587 56.7057L84.8103 47.9616C84.0701 46.6795 82.2195 46.6795 81.4793 47.9616L60.1385 84.925H73.5655L83.1537 68.3179ZM77.9659 88.1206V88.1225H58.2923L53.2605 96.8379C52.5203 98.12 53.4456 99.7226 54.926 99.7226H97.594L90.8956 88.1206H77.9659V88.1206Z",
  fill: "#009DD7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M207.236 86.8616H182.094V47H190.273V78.6318H207.236V86.8616Z",
  fill: "#009DD7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M223.688 86.8621V78.564H238.831V86.8621H223.688Z",
  fill: "#009DD7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M223.688 55.2981V47H238.831V55.2981H223.688Z",
  fill: "#009DD7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M227.11 47H235.408V86.8616H227.11V47Z",
  fill: "#009DD7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M147.486 55.1403L156.284 86.8616H164.817L153.808 47H141.409L130.066 86.8616H138.688L147.486 55.1403Z",
  fill: "#009DD7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M138.408 76.5133V69.2627H157.012V76.5133H138.408Z",
  fill: "#009DD7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M140.964 93.3704H139.093V99.6805H137.637V93.3704H135.776V92.1104H140.964V93.3704Z",
  fill: "#009DD7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M150.004 99.4632C149.552 99.6599 148.912 99.7782 148.232 99.7782C146.538 99.7782 145.574 98.7148 145.574 97.0116C145.574 95.4365 146.48 94.0776 148.084 94.0776C149.414 94.0776 150.279 95.0227 150.279 96.7954C150.279 97.0116 150.27 97.218 150.24 97.3755H146.962C147.001 98.3108 147.671 98.6855 148.459 98.6855C149 98.6855 149.423 98.5867 149.797 98.4585L150.004 99.4632ZM148.931 96.362C148.941 95.7907 148.714 95.0921 147.996 95.0921C147.297 95.0921 147.001 95.821 146.962 96.362H148.931Z",
  fill: "#009DD7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M159.105 99.5415C158.858 99.6598 158.356 99.7782 157.775 99.7782C156.171 99.7782 155.127 98.7344 155.127 96.992C155.127 95.3475 156.19 94.0874 158.002 94.0874C158.475 94.0874 158.907 94.196 159.144 94.2948L158.907 95.4071C158.72 95.3181 158.454 95.2301 158.051 95.2301C157.135 95.2301 156.604 95.9677 156.604 96.9333C156.604 98.0055 157.224 98.6258 158.061 98.6258C158.425 98.6258 158.71 98.5573 158.947 98.4487L159.105 99.5415Z",
  fill: "#009DD7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M168.854 99.6796H167.397V96.5197C167.397 95.8212 167.18 95.2792 166.55 95.2792C166.186 95.2792 165.624 95.5355 165.624 96.3524V99.6796H164.167V91.7651H165.624V94.8556H165.645C166.038 94.2853 166.639 94.0779 167.111 94.0779C168.086 94.0779 168.854 94.7871 168.854 96.4013V99.6796H168.854Z",
  fill: "#009DD7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M178.967 99.6794H177.51V96.4804C177.51 95.8102 177.293 95.279 176.673 95.279C176.28 95.279 175.738 95.5842 175.738 96.4207V99.6794H174.281V95.8503C174.281 95.2105 174.262 94.6881 174.242 94.2058H175.502L175.57 94.9444H175.601C175.846 94.5404 176.388 94.0874 177.186 94.0874C178.189 94.0874 178.967 94.7869 178.967 96.3228V99.6794Z",
  fill: "#009DD7"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M189.179 96.8932C189.179 98.9809 187.839 99.788 186.618 99.788C185.142 99.788 184.079 98.7442 184.079 96.9627C184.079 95.1215 185.191 94.0776 186.678 94.0776C188.213 94.0776 189.179 95.2301 189.179 96.8932ZM186.649 95.1508C185.841 95.1508 185.556 96.0959 185.556 96.9333C185.556 97.9077 185.93 98.7148 186.638 98.7148C187.328 98.7148 187.701 97.8979 187.701 96.9226C187.701 96.0665 187.396 95.1508 186.649 95.1508Z",
  fill: "#009DD7"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M195.816 99.6796H194.359V91.7651H195.816V99.6796Z",
  fill: "#009DD7"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M206.041 96.8932C206.041 98.9809 204.702 99.788 203.481 99.788C202.004 99.788 200.941 98.7442 200.941 96.9627C200.941 95.1215 202.053 94.0776 203.54 94.0776C205.075 94.0776 206.041 95.2301 206.041 96.8932ZM203.511 95.1508C202.703 95.1508 202.418 96.0959 202.418 96.9333C202.418 97.9077 202.792 98.7148 203.5 98.7148C204.19 98.7148 204.564 97.8979 204.564 96.9226C204.564 96.0665 204.258 95.1508 203.511 95.1508Z",
  fill: "#009DD7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M215.917 94.2058C215.888 94.6 215.868 95.0823 215.868 95.8405V98.931C215.868 100.004 215.769 101.993 213.102 101.993C212.462 101.993 211.802 101.865 211.369 101.618L211.655 100.506C211.979 100.683 212.491 100.861 213.072 100.861C213.889 100.861 214.431 100.398 214.431 99.3448V98.9408H214.411C214.136 99.3742 213.644 99.6403 213.043 99.6403C211.743 99.6403 210.926 98.4683 210.926 96.9724C210.926 95.1606 211.979 94.0874 213.191 94.0874C213.879 94.0874 214.322 94.423 214.568 94.8554H214.589L214.647 94.2058H215.917ZM214.41 96.3326C214.41 95.6331 213.988 95.2301 213.496 95.2301C212.835 95.2301 212.393 95.8992 212.393 96.9333C212.393 97.8881 212.796 98.5377 213.486 98.5377C213.821 98.5377 214.41 98.3205 214.41 97.396V96.3326H214.41Z",
  fill: "#009DD7"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M222.034 93.4784C221.572 93.4784 221.257 93.1428 221.257 92.7006C221.257 92.2477 221.581 91.9229 222.034 91.9229C222.507 91.9229 222.822 92.2477 222.822 92.7006C222.822 93.1731 222.487 93.4784 222.034 93.4784ZM222.772 99.6799H221.315V94.1965H222.772V99.6799Z",
  fill: "#009DD7"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M232.346 99.4632C231.894 99.6599 231.254 99.7782 230.574 99.7782C228.881 99.7782 227.916 98.7148 227.916 97.0116C227.916 95.4365 228.822 94.0776 230.426 94.0776C231.756 94.0776 232.622 95.0227 232.622 96.7954C232.622 97.0116 232.612 97.218 232.583 97.3755H229.304C229.343 98.3108 230.014 98.6855 230.801 98.6855C231.342 98.6855 231.766 98.5867 232.139 98.4585L232.346 99.4632ZM231.274 96.362C231.283 95.7907 231.056 95.0921 230.338 95.0921C229.639 95.0921 229.343 95.821 229.304 96.362H231.274Z",
  fill: "#009DD7"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M240.647 95.4071C240.412 95.279 240.028 95.1215 239.614 95.1215C239.171 95.1215 238.935 95.3475 238.935 95.6429C238.935 95.9482 239.142 96.1057 239.772 96.3718C240.697 96.7553 241.131 97.2875 241.131 98.0456C241.131 99.0885 240.343 99.7782 238.974 99.7782C238.374 99.7782 237.793 99.6305 237.429 99.4133L237.705 98.3607C237.99 98.5279 238.531 98.7246 238.984 98.7246C239.496 98.7246 239.742 98.5084 239.742 98.1728C239.742 97.8382 239.556 97.6612 238.955 97.4058C237.931 96.992 237.557 96.4109 237.557 95.8102C237.557 94.826 238.344 94.0776 239.565 94.0776C240.126 94.0776 240.608 94.2156 240.923 94.3829L240.647 95.4071Z",
  fill: "#009DD7"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M175.176 83.0928H171.511V86.7573H175.176V83.0928Z",
  fill: "#009DD7"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M217.37 83.0928H213.706V86.7573H217.37V83.0928Z",
  fill: "#009DD7"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M248 83.0928H244.335V86.7573H248V83.0928Z",
  fill: "#009DD7"
});

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoAli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAli);
export default __webpack_public_path__ + "static/media/logo_ali.6a389f1f.svg";
export { ForwardRef as ReactComponent };